import {useQuery} from 'react-query';

import getAllBannerImages from '.';

const useGetAllBannersImages = ({type}: {type: string}) => {
  const data = useQuery(['get-banner-images', type], getAllBannerImages);
  return data;
};

export default useGetAllBannersImages;
